import script from "./LocationCard.vue?vue&type=script&setup=true&lang=js"
export * from "./LocationCard.vue?vue&type=script&setup=true&lang=js"

import "./LocationCard.vue?vue&type=style&index=0&id=bad0230c&scoped=true&lang=css"
import "./LocationCard.vue?vue&type=style&index=1&id=bad0230c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Simeon\\Desktop\\asic-webpack\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bad0230c"]])

export default __exports__